module.exports = __webpack_public_path__ + "media/images/countryrect/li-b5a733e5e1344bfcbbec198e565882aa.svg";